import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  deleteBibliotecaFondoFamilia,
  getBibliotecasFondoFamilia,
  getBibliotecasFondoFamiliaFiltered,
  getBibliotecasFondoFamiliaById,
  insertBibliotecaFondoFamilia,
  updateBibliotecaFondoFamilia,
  updateBibliotecaFondoFamiliaAreas,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_BIBFONDOFAMILIA() {
  try {
    const bibliotecasFondoFamiliaData = yield call(getBibliotecasFondoFamilia)
    if (bibliotecasFondoFamiliaData.ok) {
      yield put({
        type: actions.BIBFONDOFAMILIA_LOAD_SUCCEEDED,
        payload: bibliotecasFondoFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFONDOFAMILIA_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFONDOFAMILIA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBFONDOFAMILIA_BY_ID(action) {
  try {
    const bibliotecasFondoFamiliaData = yield call(getBibliotecasFondoFamiliaById, action.payload)
    if (bibliotecasFondoFamiliaData.ok) {
      yield put({
        type: actions.BIBFONDOFAMILIA_LOAD_BY_ID_SUCCEEDED,
        payload: bibliotecasFondoFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFONDOFAMILIA_LOAD_BY_ID_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFONDOFAMILIA_LOAD_BY_ID_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBFONDOFAMILIA_FILTERED(action) {
  try {
    const bibliotecasPredSvgData = yield call(getBibliotecasFondoFamiliaFiltered, action.payload)
    if (bibliotecasPredSvgData.ok) {
      yield put({
        type: actions.BIBFONDOFAMILIA_FILTERED_LOAD_SUCCEEDED,
        payload: bibliotecasPredSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bibliotecas de Prediseño SVG')
      put({
        type: actions.BIBFONDOFAMILIA_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBFONDOFAMILIA_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBFONDOFAMILIA(action) {
  try {
    const etiquetasFamiliaData = yield call(deleteBibliotecaFondoFamilia, action.payload)
    if (etiquetasFamiliaData.ok) {
      yield put({
        type: actions.DELETE_BIBFONDOFAMILIA_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.DELETE_BIBFONDOFAMILIA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.DELETE_BIBFONDOFAMILIA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBFONDOFAMILIA(action) {
  try {
    const bibfondofamiliaData = yield call(updateBibliotecaFondoFamilia, action.payload)
    if (bibfondofamiliaData.ok) {
      putMessage(messageType.SUCCESS, 'Cambios guardados')
      yield put({
        type: actions.BIBFONDOFAMILIA_UPDATE_SUCCEEDED,
        payload: bibfondofamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFONDOFAMILIA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFONDOFAMILIA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBFONDOFAMILIA_AREAS(action) {
  try {
    const bibfondofamiliaData = yield call(updateBibliotecaFondoFamiliaAreas, action.payload)
    if (bibfondofamiliaData.ok) {
      putMessage(messageType.SUCCESS, 'Cambios guardados')
      yield put({
        type: actions.BIBFONDOFAMILIA_UPDATE_SUCCEEDED,
        payload: bibfondofamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFONDOFAMILIA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFONDOFAMILIA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBFONDOFAMILIA(action) {
  try {
    const bibfondofamiliaData = yield call(insertBibliotecaFondoFamilia, action.payload)
    if (bibfondofamiliaData.ok) {
      putMessage(messageType.SUCCESS, 'Creada correctamente')
      yield put({
        type: actions.BIBFONDOFAMILIA_INSERT_SUCCEEDED,
        payload: { ...bibfondofamiliaData.data, fontFamily: action.payload?.fontFamily },
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFONDOFAMILIA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFONDOFAMILIA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BIBFONDOFAMILIA_LOAD_REQUESTED, GET_BIBFONDOFAMILIA),
    takeEvery(actions.BIBFONDOFAMILIA_LOAD_BY_ID_REQUESTED, GET_BIBFONDOFAMILIA_BY_ID),
    takeEvery(actions.BIBFONDOFAMILIA_FILTERED_LOAD_REQUESTED, GET_BIBFONDOFAMILIA_FILTERED),
    takeEvery(actions.DELETE_BIBFONDOFAMILIA_REQUESTED, DELETE_BIBFONDOFAMILIA),
    takeEvery(actions.BIBFONDOFAMILIA_UPDATE_REQUESTED, UPDATE_BIBFONDOFAMILIA),
    takeEvery(actions.BIBFONDOFAMILIA_UPDATE_AREAS_REQUESTED, UPDATE_BIBFONDOFAMILIA_AREAS),
    takeEvery(actions.BIBFONDOFAMILIA_INSERT_REQUESTED, INSERT_BIBFONDOFAMILIA),
  ])
}
